import React, { useState } from 'react';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
import CallUpdate from './CallUpdate';

const CallPromptModal = ({ onClose, show, callUser, profile, callId, calling, number }) => {
  const [open, setOpen] = useState(false);
  const makeCall = () => {
    callUser();
    setOpen(true);
  };
  const onCloseUpdate = () => {
    setOpen(false);
    onClose()
  };
  if (!show) return null;
  return (
    <>
      <div className="modal-root"> 
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" style={{ paddingLeft: '2rem' }}>Confirm</h4>
              <button 
                type="button" 
                className="close" 
                onClick={onClose}
                aria-hidden="true"
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              Are you sure you want to call this customer?
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => makeCall()}>
                Call
              </button>
              <button className="btn btn-primary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <CallUpdate
        onClose={onCloseUpdate}
        show={open}
        profile={profile}
        callId={callId}
        calling={calling}
        number={number}
      />
    </>
  );
};
export default CallPromptModal;
